import { useLoaderData } from '@remix-run/react';
import type { DeviceContextType } from '@archipro-website/types';

import type { PaginatedProductsProp } from '@modules/professional/component/products-tab/PaginatedProducts';
import { PaginatedProducts } from '@modules/professional/component/products-tab/PaginatedProducts';
import { useIsDisabledInPreview } from '@modules/root/hook/use-is-disabled-in-preview';

interface Loader extends PaginatedProductsProp {
    deviceType: DeviceContextType;
}

const OurProductsPage = () => {
    const loaderData = useLoaderData() as Loader;
    const disableTileLink = useIsDisabledInPreview('featured_tile_links');
    const disableSaveToDesignBoard =
        useIsDisabledInPreview('save_design_board');
    const disableSort = useIsDisabledInPreview('directory_sort');
    return (
        <PaginatedProducts
            {...loaderData}
            disableTileLink={disableTileLink}
            disableSaveToDesignBoard={disableSaveToDesignBoard}
            disableSort={disableSort}
        />
    );
};

export default OurProductsPage;
